import { Link } from "react-router-dom";

// Convierte los TE (TE-YYMMDD-NNNNNN) que cita la IA en links al caso. Resuelve
// vía /t/:te (que llama a /api/casos/por-te) para que funcione aunque el texto esté
// cacheado. El resto del texto se respeta tal cual (usar con whitespace-pre-wrap).
const TE_SPLIT = /(TE-\d{6}-\d{6})/g;
const TE_ONE = /^TE-\d{6}-\d{6}$/;

export default function TextoConTE({
  texto,
  className,
}: {
  texto: string;
  className?: string;
}) {
  return (
    <span className={className}>
      {texto.split(TE_SPLIT).map((parte, i) =>
        TE_ONE.test(parte) ? (
          <Link
            key={i}
            to={`/t/${parte}`}
            className="text-accent-300 font-mono hover:underline"
            aria-label={`Ir al caso ${parte}`}
          >
            {parte}
          </Link>
        ) : (
          parte
        ),
      )}
    </span>
  );
}
